import { Navigation } from "./components/Navigation";
import ReactGA from "react-ga";
import { useEffect } from "react";
import { MODE } from "./constants";
import { Toaster } from "react-hot-toast";
/**
 * Main component used by the application, sets font for entire application and initializes google analytics
 * @see Navigation
 * @returns
 */
function App() {
  useEffect(() => {
    if (MODE) ReactGA.initialize("G-Z2BRL5M16T");
  }, []);
  return (
    <div className="font-base">
      <Navigation />
      <Toaster />
    </div>
  );
}

export default App;
